import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent}  from './admin/login.component';
import {DashboardComponent}  from './admin/dashboard/dashboard.component';
import {BanksComponent}  from './admin/banks/banks.component';
import {AddBankComponent}  from './admin/add-bank/add-bank.component';
import {AddUpdateComponent}  from './admin/add-update/add-update.component';
import {UpdatesComponent}  from './admin/updates/updates.component';
import {ResetComponent}  from './admin/reset/reset.component';
import {BankDetailComponent}  from './admin/bank-detail/bank-detail.component';
import {PrivacyPolicyComponent}  from './admin/privacy-policy/privacy-policy.component';
import {UpdateDetailComponent}  from './admin/update-detail/update-detail.component';
import {IndexComponent}  from './landing-page/index/index.component';
import {AboutComponent}  from './landing-page/about/about.component';


const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  {path:'admin',component:LoginComponent},
{path:'dashboard',component:DashboardComponent},
{path:'banks',component:BanksComponent},
{path:'updates',component:UpdatesComponent},
{path:'bank-detail',component:BankDetailComponent},
{path:'update-detail',component:UpdateDetailComponent},
{path:'add-bank',component:AddBankComponent},
{path:'add-update',component:AddUpdateComponent},
{path:'reset/password',component:ResetComponent},
{path:'terms-conditions',component:PrivacyPolicyComponent},
{path:'',component:IndexComponent},
{path:'about',component:AboutComponent},



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
